module.exports = __webpack_public_path__ + "static/sportovni-den-2022-06-ac5a2a1359b76058ffb04dce19f02b7c.jpg";